import {
  ContentsHeader,
  InformationBanner,
  Spinner,
} from "@graffer-inc/console-design-kit";
import { SmartApplyMenuList } from "../../../../organisms/smart-apply/menu-list";
import { SmartApplyTemplate } from "../../../../template/smart-apply/default-template";
import { useAuthContextV2 } from "../../../../../auth-state";
import { QualifiedInvoiceIssueRequestsContainerHooks } from "./hooks";
import { UnhandledQualifiedInvoiceIssueRequestsTable } from "./table/unhandled";

export const QualifiedInvoiceIssueRequestsContainer = () => {
  const { auth } = useAuthContextV2();
  if (!auth.hasPermissions("qualified_invoice_issue_request.list")) {
    return <></>;
  }
  if (!auth.usePayment && !auth.usePaymentPayeasy) {
    return <></>;
  }

  const { isLoading, issueRequests } =
    QualifiedInvoiceIssueRequestsContainerHooks({
      orgId: auth.data?.orgId || "",
    });

  return (
    <SmartApplyTemplate
      breadcrumbs={[]}
      menuList={<SmartApplyMenuList />}
      contentsHeader={
        <ContentsHeader
          title={"交付依頼一覧"}
          captionDirection="row"
          border={false}
        >
          <p>
            未対応の支払い明細書の交付依頼を表示しています。
            <br />
            支払い明細書を交付するもしくは、交付依頼を取り下げることで対応完了となります。
          </p>
        </ContentsHeader>
      }
    >
      <Spinner loading={isLoading} />
      {issueRequests.length > 0 ? (
        <div className="mb-4">
          <UnhandledQualifiedInvoiceIssueRequestsTable
            isLoading={isLoading}
            issueRequests={issueRequests}
          />
        </div>
      ) : (
        <InformationBanner message="未対応の交付依頼はありません。" />
      )}
    </SmartApplyTemplate>
  );
};
